module.exports = __webpack_public_path__ + "static/christopher-chedeau-react-origin-0c92061ec0d6cf7b89c1ea072ea7282e.png";